import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { MarkHotkey } from 'libs/editor/plugins/helpers/markHotKey';
import { RenderMark } from 'libs/editor/plugins/helpers/renderMark';
import { HasMark } from 'libs/editor/plugins/helpers/hasMark';

export const CodeMark = observer(({ children }) => (
  <CodeStyle>{children}</CodeStyle>
));

const CodeStyle = styled.code`
  padding: 0px 2px;
  background-color: ${props => props.theme.color.wfGrey200};
  border: 1px solid ${props => props.theme.color.wfGrey300};
  font-size: 0.8em;
  color: ${props => props.theme.color.primary};
`;

const type = 'CODE';

export function Code() {
  return {
    button: {
      elementType: 'mark',
      type,
      active: value => HasMark(type, value),
      handleClick: store => {
        const { reference, onChange } = store;
        reference.toggleMark(type);
        onChange(reference);
      },
    },
    plugins: [
      MarkHotkey({ key: "'", type }),
      RenderMark(type, props => <CodeMark {...props} />),
    ],
  };
}
